const DevPage = () => {
  return <div />;
};

export default DevPage;
